module.exports = __webpack_public_path__ + "img/logo-dark.a5a6af2c.png";